import createIcon from '../../createIcon';

/**
 * @component @name SensorDoor
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggMkg2QzQuOSAyIDQgMi45IDQgNFYyMkgyMFY0QzIwIDIuOSAxOS4xIDIgMTggMlpNMTUuNSAxMy41QzE0LjY3IDEzLjUgMTQgMTIuODMgMTQgMTJDMTQgMTEuMTcgMTQuNjcgMTAuNSAxNS41IDEwLjVDMTYuMzMgMTAuNSAxNyAxMS4xNyAxNyAxMkMxNyAxMi44MyAxNi4zMyAxMy41IDE1LjUgMTMuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SensorDoor = createIcon('SensorDoor', [
  [
    'path',
    {
      d: 'M18 2H6C4.9 2 4 2.9 4 4V22H20V4C20 2.9 19.1 2 18 2ZM15.5 13.5C14.67 13.5 14 12.83 14 12C14 11.17 14.67 10.5 15.5 10.5C16.33 10.5 17 11.17 17 12C17 12.83 16.33 13.5 15.5 13.5Z',
      key: 'qdcdog',
    },
  ],
]);

export default SensorDoor;
